import { ProductCustomizationModifiers } from 'features/menu/components/product-detail/product-customization/product-customization-modifiers';
import { ProductItemFlowContainer } from 'features/menu/components/product-detail/product-detail-flow/product-item/styled';

interface IProductItemFlowProps {}

export const ProductItem: React.FC<IProductItemFlowProps> = () => {
  return (
    <ProductItemFlowContainer testID="product-item-flow">
      <ProductCustomizationModifiers />
    </ProductItemFlowContainer>
  );
};
